import { HttpClient } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { AdminUser, TokenResponse } from '../../shared/models';
import { environment } from '../../../environments/environment';

const ADMIN_TOKEN_KEY = 'admin_token';

@Injectable({ providedIn: 'root' })
export class AdminAuthService {
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);

  private readonly _user = signal<AdminUser | null>(null);
  readonly user = this._user.asReadonly();
  readonly isAuthenticated = computed(() => this._user() !== null);

  getToken(): string | null {
    return localStorage.getItem(ADMIN_TOKEN_KEY);
  }

  login(username: string, password: string): Observable<TokenResponse> {
    return this.http.post<TokenResponse>(`${environment.apiUrl}/admin/auth/login`, { username, password }).pipe(
      tap((res) => {
        localStorage.setItem(ADMIN_TOKEN_KEY, res.access_token);
      })
    );
  }

  loadCurrentUser(): Observable<AdminUser> {
    return this.http.get<AdminUser>(`${environment.apiUrl}/admin/auth/me`).pipe(
      tap((user) => this._user.set(user))
    );
  }

  changePassword(currentPassword: string, newPassword: string): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/admin/auth/password`, {
      current_password: currentPassword,
      new_password: newPassword,
    });
  }

  setPassword(token: string, newPassword: string): Observable<void> {
    return this.http.post<void>(`${environment.apiUrl}/admin/auth/set-password`, {
      token,
      new_password: newPassword,
    });
  }

  logout(): void {
    localStorage.removeItem(ADMIN_TOKEN_KEY);
    this._user.set(null);
    this.router.navigate(['/admin/login']);
  }
}
